var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnDownloadSquare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5126 7V12.25H1.86553V7H0.20166V12.25C0.20166 13.075 0.9504 13.75 1.86553 13.75H13.5126C14.4277 13.75 15.1765 13.075 15.1765 12.25V7H13.5126ZM8.52099 7.5025L10.6757 5.5675L11.8487 6.625L7.68906 10.375L3.52939 6.625L4.70242 5.5675L6.85712 7.5025V0.25H8.52099V7.5025Z",
    fill: "#007bff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnDownloadSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-download-square.67f5ec59.svg";
export { ForwardRef as ReactComponent };